// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DetailInfo_wrapper_ASBNW"};